import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

/** Old Pending URL — send people to Action required. */
export default class CoachingCoachSessionsPendingRoute extends Route {
  @service declare router: RouterService;

  beforeModel(): void {
    this.router.replaceWith('coaching.coach.sessions.action-required');
  }
}
